/**
 * Created by agengmaulana on 7/20/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import {observer} from "mobx-react"
import {reaction, autorunAsync} from "mobx"

@observer
export default class Comment_Article_Reply extends React.Component{

    constructor(props) {
        super(props);

    }

    render(){
        var textarticle = this.props.comarticle == 1 ? 'Selengkapnya' : 'Balas'
        return(
             this.props.comarticle == 1 ? <a href="javascript:void(0);" className={styles.cmt_mr15 +' '+styles.cmt_dk_balas+' '+styles.cmt_href}  onClick={this.goanchor} >Selengkapnya</a> :
                <a href="javascript:void(0);" className={styles.cmt_mr15 +' '+styles.cmt_dk_balas+' '+styles.cmt_href}  onClick={this.goanchor} >Balas</a>
        )
    }


     goanchor=()=>{
         this.props.datFunction.anchor = this.props.id
         this.props.datFunction.anchormaster = this.props.parent_id
         this.props.datFunction.fetchDataKomentar(0,'newest',this.props.id)

         setTimeout(() => {
            this.props.datFunction.configKomentar.onscroll(this.props.id)
            document.getElementById("reply-"+this.props.id).click();
         }, 700);


    }
}



// WEBPACK FOOTER //
// ./static/src/component/comment_article/comment_article_reply.js